var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2426 5.17156C12.6332 4.78104 12.6332 4.14787 12.2426 3.75735C11.8521 3.36683 11.219 3.36683 10.8284 3.75735L8 6.58578L5.17157 3.75735C4.78105 3.36683 4.14788 3.36683 3.75736 3.75735C3.36684 4.14787 3.36683 4.78104 3.75736 5.17156L6.58579 7.99999L3.75736 10.8284C3.36684 11.2189 3.36684 11.8521 3.75736 12.2426C4.14788 12.6332 4.78105 12.6332 5.17157 12.2426L8 9.4142L10.8284 12.2426C11.219 12.6332 11.8521 12.6332 12.2426 12.2426C12.6332 11.8521 12.6332 11.2189 12.2426 10.8284L9.41421 7.99999L12.2426 5.17156Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGrey);
export default __webpack_public_path__ + "static/media/cross-grey.15351608cd7f2adb20c6085639b3e34c.svg";
export { ForwardRef as ReactComponent };